import { MutableRefObject, useEffect, useState } from 'react';

// Calculates unexpanded height using wrapper y - 4th element y
export const useExpandablePersonalisationOptions = (
  wrapperRef: MutableRefObject<HTMLUListElement | null>,
  fourthElementRef: MutableRefObject<HTMLLIElement | null>,
  expandable: boolean,
) => {
  const [unexpandedHeight, setUnexpandedHeight] = useState(0);
  const [fadeHeight, setFadeHeight] = useState(0);

  useEffect(() => {
    if (expandable) {
      const {
        y: fourthElementY,
        height: fourthElementHeight,
      } = fourthElementRef.current?.getBoundingClientRect() as DOMRect;

      const { y: wrapperY } = wrapperRef.current?.getBoundingClientRect() as DOMRect;

      if (fourthElementY && wrapperY) {
        setUnexpandedHeight(fourthElementY + fourthElementHeight - wrapperY);
        setFadeHeight(fourthElementHeight / 1.5);
      }
    }
  }, [wrapperRef, fourthElementRef, expandable]);

  return {
    unexpandedHeight,
    fadeHeight,
  };
};
